import { Type } from "@sinclair/typebox";

export enum SortCriteria {
  Date = "date",
  Number = "number",
}

export const PaginationSchema = Type.Object({
  pages: Type.Number({ minimum: 0 }),
  pageSize: Type.Number({ minimum: 0 }),
});

export const PaginationParamsSchema = Type.Object({
  page: Type.Number({ minimum: 0 }),
});

export const SortParamSchema = Type.Object({
  sortCriteria: Type.Optional(Type.Enum(SortCriteria)),
});

export const Domain = Type.Object({
  domainName: Type.String(),
  isPrimary: Type.Boolean(),
});
